import React from 'react';
import { connect } from 'react-redux';
import ResendFormSC, { ResendFormTextInputSC, ResendFormErrorSC } from './resend-form.styled';
import { Formik } from 'formik';
import ResendFormSchema from './resend-form-rules';
import { BodyText, SmallText } from '../../typography';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import Button from '../../ui/button';

const _ResendForm = ({ onSubmitForm, isLoading }) => {
  const formInitialValues = {
    id: '',
  };

  return (
    <ResendFormSC>
      <Formik
        enableReinitialize
        initialValues={formInitialValues}
        validationSchema={ResendFormSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          onSubmitForm(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => {
          const idHasError = errors && errors.id && touched.id;

          return (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="heading-block">
                  <BodyText className="bolder">
                    <FormattedMessage
                      id="login_form_wm_id"
                      defaultMessage={dlt['login_form_wm_id']}
                    />
                  </BodyText>
                  <div className="separator"></div>
                </div>

                <div className="full-block">
                  <FormattedMessage
                    id="login_form_wm_id_placeholder"
                    defaultMessage={dlt['login_form_wm_id_placeholder']}
                  >
                    {(placeholder) => (
                      <ResendFormTextInputSC
                        type="text"
                        name="id"
                        placeholder={placeholder}
                        filled={values.id}
                        hasError={idHasError}
                        onChange={(e) => {
                          setFieldValue('id', e.target.value.replace(/[^a-zA-Z0-9]/g, ''));
                        }}
                        onBlur={handleBlur}
                        value={values.id || ''}
                      />
                    )}
                  </FormattedMessage>
                  {idHasError ? (
                    <ResendFormErrorSC>
                      <FormattedMessage id={errors.id} defaultMessage={dlt[errors.id]} />
                    </ResendFormErrorSC>
                  ) : null}
                </div>
                <div className="full-block centered">
                  <SmallText className="black-transparent bigger">
                    <FormattedMessage
                      id="login_resend_forgot_id"
                      defaultMessage={dlt['login_resend_forgot_id']}
                    />
                  </SmallText>
                </div>
              </div>

              <div className="row">
                <div className="full-block">
                  <Button
                    type="PRIMARY"
                    className="form-submit"
                    onClick={handleSubmit}
                    disabled={isLoading}
                  >
                    <FormattedMessage id="global_send" defaultMessage={dlt['global_send']} />
                  </Button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </ResendFormSC>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.user,
  };
};

const ResendForm = connect(mapStateToProps)(_ResendForm);

export default ResendForm;
